import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { formatStopTime } from '@/utils/timeStrings'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsItineraryItemPickupTime',
  props: {
    pickupDatetime: null,
    timeZone: null
  },
  setup(__props: any) {

const props = __props as {
  pickupDatetime: string
  timeZone: string
};



const stopTime = computed(() => {
  return formatStopTime(props.pickupDatetime, props.timeZone)
})

return { __sfc: true,props, stopTime }
}

})